import { announceForeground, announceReconnect } from "@heraion/shared";

// #397, the web twin of apps/mobile/src/net/onlineState.ts, same name for the
// same meaning: no network at all. `navigator.onLine` false is sure; true
// only means "maybe", so unknown stays connected.
export const isKnownDisconnected = (): boolean =>
  typeof navigator !== "undefined" && navigator.onLine === false;

/** Boot (main.tsx): the window's `online` is the reconnect signal. */
export function startReconnectSignal(): void {
  if (typeof window === "undefined") return;
  window.addEventListener("online", announceReconnect);
  // #509: the tab visible again is the foreground.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") announceForeground();
  });
}
